import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, UserCog } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ROLE_LABEL = {
  six_admin: "SIX Admin",
  six_consultant: "SIX Consultant",
  client_user: "Client User",
  demo_viewer: "Demo Viewer",
};

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const initials = (user.name || user.email).split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex items-center justify-center rounded-lg w-8 h-8 text-[11px] font-bold text-white bg-[--six-crimson] hover:bg-[--six-crimson-hover] transition-colors"
          data-testid="user-menu-trigger" title={user.email}>
          {initials}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[240px] bg-[--shell-1] border-[--hairline]" data-testid="user-menu-content">
        <DropdownMenuLabel>
          <div className="text-xs font-semibold text-[--tx-1]" data-testid="user-menu-name">{user.name}</div>
          <div className="text-[10px] text-[--tx-3] font-normal">{user.email}</div>
          <div className="mt-1 inline-flex items-center gap-1 text-[9px] font-mono uppercase tracking-wider text-[--ai]">
            <ShieldCheck size={10} /> {ROLE_LABEL[user.role] || user.role}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-[--divider]" />
        {user.role === "six_admin" && (
          <DropdownMenuItem onClick={() => navigate("/admin")} className="text-xs cursor-pointer text-[--tx-2]" data-testid="user-menu-admin-link">
            <UserCog size={13} className="mr-2" /> Admin console
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={logout} className="text-xs cursor-pointer text-[--tx-2]" data-testid="user-menu-logout">
          <LogOut size={13} className="mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
